import type { GetVaultData } from "../query"

/**
 * Checks if a collateral is active based on liquidationLTV and targetTimestamp
 */
export function isActiveCollateral(
  ltvInfo: NonNullable<GetVaultData>["collateralLTVInfo"][0],
): boolean {
  const currentTimestamp = Math.floor(Date.now() / 1000)
  return (
    ltvInfo.liquidationLTV > 0n ||
    ltvInfo.targetTimestamp > BigInt(currentTimestamp)
  )
}

/**
 * Checks if a collateral is borrowable based on borrowLTV, liquidationLTV and targetTimestamp
 */
export function isBorrowableCollateral(
  ltvInfo: NonNullable<GetVaultData>["collateralLTVInfo"][0],
  totalBorrowed?: bigint,
): boolean {
  const currentTimestamp = Math.floor(Date.now() / 1000)
  return Boolean(
    (ltvInfo.borrowLTV > 0n && ltvInfo.liquidationLTV > 0n) ||
      ltvInfo.targetTimestamp > BigInt(currentTimestamp) ||
      (totalBorrowed && totalBorrowed > 0n && ltvInfo.liquidationLTV > 0n),
  )
}
